"use client";
import Image from "@components/atoms/Image";
import styles from "./FeatureCard.module.scss";
import MileageModal from "../MileageModal";
import { useState } from "react";
import Button from "@components/atoms/Button";
import assetLoader from "@utils/internalImageLoder";
import { formatDeliveryDate } from "@utils/formatDate";

type FeatureT = any;

interface FeatureCardProps {
  feature: FeatureT;
  isSellable: boolean;
  brandName?: string;
  modelName?: string;
  cityName?: string;
  carAvailability?: string;
  pageType?: string;
}

export function FeatureCard({
  feature,
  isSellable,
  brandName,
  modelName,
  cityName,
  carAvailability,
  pageType,
}: FeatureCardProps) {
  const [openVariantModal, setOpenVariantModal] = useState<boolean>(false);

  const handleCTAClick = () => {
    setOpenVariantModal(true);
  };
  const variants = (feature.availableVariants || []).map((variant: any) => ({
    name: variant.name,
    variantName: variant.variantName,
    fuelType: variant.fuelType,
    transmission: variant.transmissionType,
    onRoadPrice: variant.onRoadPrice,
    slug: variant.slug,
    mileage: variant.mileage ? variant.mileage : null,
    expressDelivery: variant.expressDeliveryAvailable,
    standardDelivery: formatDeliveryDate(
      variant.expressDeliveryDays || variant.standardDeliveryDays
    ),
  }));

  return (
    <div key={feature.id} className={styles.featureCard}>
      <div className={styles.imageContainer}>
        <Image
          src={feature?.media?.[0]?.url}
          alt={feature.title}
          width={400}
          height={300}
          className={styles.featureImage}
          loading="lazy"
        />
      </div>
      <Button
        className={styles.variantsBtn}
        onButtonClick={handleCTAClick}
        segmentEventProps={{
          eventName: "action",
          pageType: pageType,
          eventProperties: {
            action_type: "tap_btn",
            action_name: "tap_btn_variant",
            section: "Standout feature",
            car_availability: carAvailability,
            city_name: cityName,
            vehicle_make: brandName,
            vehicle_model: modelName,
          },
        }}
      >
        {`Available in ${feature.availableVariants.length} variants`}
        <Image
          src={`${assetLoader()}/icons/expertReview/Chevron_right.svg`}
          alt={"Right Arrow"}
          className={styles.navIcon}
          width={20}
          height={20}
          loading="lazy"
        />
      </Button>
      <h3 className={styles.featureTitle}>{feature.category}</h3>
      <p className={styles.featureDescription}>{feature.description}</p>
      {openVariantModal && (
        <MileageModal
          isOpen={openVariantModal}
          onClose={() => {
            setOpenVariantModal(false);
          }}
          title={`Available in ${feature.availableVariants.length} variants`}
          customStyles={{
            modalOverlay: styles.modalOverlay,
            modalContent: styles.modalContainer,
          }}
          variants={variants}
          preventScoll={true}
          isSellable={isSellable}
          carAvailability={carAvailability}
          pageType={pageType}
        />
      )}
    </div>
  );
}
